module.exports = __webpack_public_path__ + "img/cat-logo copy.8bbaf04f.jpg";